import { SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import FeatureCard from '../FeatureCard/FeatureCard';
import ArrowRightIconV2 from '../SVGIcons/ArrowRightIconV2';
import Slider from '../UI/Slider';
import classes from './features-block.module.scss';

interface IFeaturesBlockProps {
  title: string;
  cards:
    | {
        id: string;
        title: string;
        subtitle: string;
        image: string;
      }[]
    | null;
  buttonText: string;
}

function FeaturesBlock({ title, cards, buttonText }: IFeaturesBlockProps) {
  return (
    <div className={classes.features}>
      {cards && (
        <Slider title={title} isColored={false}>
          <SplideTrack>
            {cards.map((card) => (
              <SplideSlide key={card.id}>
                <FeatureCard
                  key={card.id}
                  title={card.title}
                  icon={card.image}
                  text={card.subtitle}
                />
              </SplideSlide>
            ))}
          </SplideTrack>
        </Slider>
      )}

      <Link to="catalog-vacancies" className={classes.vacancies}>
        {buttonText}
        <div>
          <ArrowRightIconV2 fill="white" />
        </div>
      </Link>
    </div>
  );
}

export default memo(FeaturesBlock);
